import { c as _c } from "react/compiler-runtime";
import type { ColumnDefinition } from '@xefi/x-react/datagrid';
import { TruncatedText } from '@xefi/x-react/typography';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Status } from '@/models/status';
import type { SurveyHome } from '@/models/survey';
import type { SurveyTab } from '@/store/mainSlice';
import { ActionButtonsRenderCell } from '../_components/ActionButtonsRenderCell/ActionButtonsRenderCell';
import { CountDownRenderCell } from '../_components/CountDownRenderCell';
import { UpdateStatusRenderCell } from '../_components/UpdateStatusRenderCell';
export const useSurveyColumns = t0 => {
  const $ = _c(37);
  const {
    statuses,
    setSurveyTab
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  let t2;
  if ($[0] !== t) {
    t2 = t("survey.title");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2 as string;
  let t4;
  if ($[2] !== t) {
    t4 = row => <div className="w-full"><TruncatedText className="truncate text-sm">{row.title}</TruncatedText><p className="text-xs leading-6">{`${t("survey.dates.created")} : ${dayjs(row.created_at).format("DD/MM/YYYY")}`}</p><p className="text-xs leading-6">{`${t("survey.dates.modified")} ${dayjs(row.updated_at).format("DD/MM/YYYY")}${row.updated_by?.firstname && row.updated_by?.lastname ? t("survey.dates.updateBy", {
          firstname: row.updated_by.firstname,
          lastname: row.updated_by.lastname
        }) : ""}`}</p></div>;
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      field: "title.keyword",
      header: t3,
      sortable: true,
      cell: t4
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("status", {
      ns: "common"
    });
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = t6 as string;
  let t8;
  if ($[9] !== statuses) {
    t8 = row_0 => <UpdateStatusRenderCell key={row_0.id} survey={row_0} statuses={statuses} />;
    $[9] = statuses;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = {
      field: "status",
      header: t7,
      sortable: true,
      cell: t8
    };
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("survey.nbResponses");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = t10 as string;
  let t12;
  if ($[16] !== t11) {
    t12 = {
      field: "entries_count",
      header: t11,
      sortable: false,
      cell: _temp
    };
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t) {
    t13 = t("survey.creator");
    $[18] = t;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  const t14 = t13 as string;
  let t15;
  if ($[20] !== t14) {
    t15 = {
      field: "creator.lastname.keyword",
      header: t14,
      className: "min-w-24",
      sortable: true,
      cell: _temp2
    };
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t) {
    t16 = t("time.left");
    $[22] = t;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  const t17 = t16 as string;
  let t18;
  if ($[24] !== t17) {
    t18 = {
      header: t17,
      className: "min-w-44",
      sortable: false,
      cell: _temp3
    };
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== setSurveyTab) {
    t19 = {
      field: "actions" as const,
      header: "Actions",
      className: "w-56",
      sortable: false,
      cell: row_4 => <ActionButtonsRenderCell {...row_4} setSurveyTab={setSurveyTab} />
    };
    $[26] = setSurveyTab;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t12 || $[29] !== t15 || $[30] !== t18 || $[31] !== t19 || $[32] !== t5 || $[33] !== t9) {
    t20 = [t5, t9, t12, t15, t18, t19];
    $[28] = t12;
    $[29] = t15;
    $[30] = t18;
    $[31] = t19;
    $[32] = t5;
    $[33] = t9;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  t1 = t20 as ColumnDefinition<SurveyHome>[];
  const columns = t1;
  let t21;
  if ($[35] !== columns) {
    t21 = {
      columns
    };
    $[35] = columns;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  return t21;
};
function _temp(row_1) {
  return <div className="flex flex-wrap"><div><span>{row_1.entries_count}</span>{row_1.max_entries && <span>/{row_1.max_entries}</span>}</div></div>;
}
function _temp2(row_2) {
  return <div><p>{`${row_2.creator.firstname} ${row_2.creator.lastname}`}</p></div>;
}
function _temp3(row_3) {
  return <CountDownRenderCell {...row_3} />;
}